<div class="absolute text-center -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
  <nrc-loading-spinner />
</div>
